import React, { useState, useEffect } from 'react';
import api from '../services/api';

// ==================================================================================
// ÍCONES MINIMALISTAS (Stroke 1.5 a 2.0 - Estilo Lucide/Vercel)
// ==================================================================================
const Icons = {
  Plus: () => <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>,
  Edit: () => <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path></svg>,
  Trash: () => <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path><line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line></svg>,
  Camera: () => <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"></path><circle cx="12" cy="13" r="4"></circle></svg>,
  Close: () => <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>,
  ArrowLeft: () => <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><line x1="19" y1="12" x2="5" y2="12"></line><polyline points="12 19 5 12 12 5"></polyline></svg>,
  Package: () => <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><line x1="16.5" y1="9.4" x2="7.5" y2="4.21"></line><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path><polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline><line x1="12" y1="22.08" x2="12" y2="12"></line></svg>
};

// COMPRESSOR DE IMAGEM NATIVO (Transforma foto pesada em um Base64 leve)
const compressImage = (file) => {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (event) => {
      const img = new Image();
      img.src = event.target.result;
      img.onload = () => {
        const canvas = document.createElement('canvas');
        const MAX_WIDTH = 800; // Tamanho máximo
        const scaleSize = MAX_WIDTH / img.width;
        canvas.width = MAX_WIDTH;
        canvas.height = img.height * scaleSize;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        // Comprime para JPEG com 70% de qualidade
        resolve(canvas.toDataURL('image/jpeg', 0.7)); 
      };
    };
  });
};

function formatarPreco(valor) {
  return Number(valor || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
}

export default function Produtos() {
  const [produtos, setProdutos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modalOpen, setModalOpen] = useState(false);
  const [saving, setSaving] = useState(false);

  const [form, setForm] = useState({ id: null, nome: '', categoria: 'Lente', preco: '', estoque: '', descricao: '', imagemBase64: '' });

  const fetchProdutos = async () => {
    try {
      const res = await api.get('/produtos');
      setProdutos(res.data);
    } catch (e) { 
      console.error(e); 
    } finally { 
      setLoading(false); 
    }
  };

  useEffect(() => { fetchProdutos(); }, []);

  const openModal = (prod = null) => {
    if (prod) {
      setForm({ id: prod._id, nome: prod.nome, categoria: prod.categoria, preco: prod.preco, estoque: prod.estoque, descricao: prod.descricao, imagemBase64: prod.imagemBase64 || '' });
    } else {
      setForm({ id: null, nome: '', categoria: 'Lente', preco: '', estoque: '', descricao: '', imagemBase64: '' });
    }
    setModalOpen(true);
  };

  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (!file.type.startsWith('image/')) return alert('Selecione apenas imagens.');
    
    // Comprime e salva no state
    const compressedBase64 = await compressImage(file);
    setForm({ ...form, imagemBase64: compressedBase64 });
  };

  const saveProduto = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const payload = { ...form, preco: Number(form.preco), estoque: Number(form.estoque) };
      
      if (form.id) await api.put(`/produtos/${form.id}`, payload);
      else await api.post('/produtos', payload);
      
      setModalOpen(false);
      fetchProdutos();
    } catch (e) { 
      alert("Erro ao salvar produto"); 
    } finally { 
      setSaving(false); 
    }
  };

  const deleteProduto = async (id) => {
    if(!window.confirm("Deseja realmente apagar este produto? Esta ação não pode ser desfeita.")) return;
    try {
      await api.delete(`/produtos/${id}`);
      fetchProdutos();
    } catch (e) { 
      alert("Erro ao apagar"); 
    }
  };

  return (
    <div className="layout-container">
      <GlobalStyles />

      {/* HEADER DA PÁGINA */}
      <header className="page-header animate-fade-in">
        <div className="header-left">
          <button onClick={() => window.history.back()} className="btn-icon">
            <Icons.ArrowLeft />
          </button>
          <div className="header-titles">
            <h1>Estoque & Produtos</h1>
            <p>Gerencie seu catálogo de lentes, armações e acessórios.</p>
          </div>
        </div>

        <button className="btn-primary" onClick={() => openModal()}>
          <Icons.Plus /> Novo Produto
        </button>
      </header>

      {/* GRID DE PRODUTOS */}
      <main className="page-content animate-fade-in">
        {loading ? (
          <div className="empty-state">
            <div className="spinner"></div>
            <p>Buscando catálogo...</p>
          </div>
        ) : produtos.length === 0 ? (
          <div className="empty-state">
            <div className="empty-icon"><Icons.Package /></div>
            <h3>Estoque Vazio</h3>
            <p>Seu catálogo de produtos aparecerá aqui.</p>
            <button className="btn-primary" onClick={() => openModal()}>Adicionar o Primeiro</button>
          </div>
        ) : (
          <div className="products-grid">
            {produtos.map(prod => (
              <div key={prod._id} className="product-card">
                
                <div className="card-image-box">
                  {prod.imagemBase64 ? (
                    <img src={prod.imagemBase64} alt={prod.nome} className="product-image" />
                  ) : (
                    <div className="no-image"><Icons.Camera /></div>
                  )}
                  <span className="category-badge">{prod.categoria}</span>
                </div>

                <div className="card-body">
                  <div className="product-info">
                    <h3 className="product-name" title={prod.nome}>{prod.nome}</h3>
                    <p className="product-desc" title={prod.descricao}>{prod.descricao || 'Sem descrição detalhada'}</p>
                  </div>
                  
                  <div className="product-metrics">
                    <span className="product-price">{formatarPreco(prod.preco)}</span>
                    <span className={`product-stock ${prod.estoque <= 0 ? 'stock-out' : ''}`}>
                      {prod.estoque} em estoque
                    </span>
                  </div>
                </div>

                <div className="card-actions">
                  <button onClick={() => openModal(prod)} className="btn-ghost action-btn">
                    <Icons.Edit /> Editar
                  </button>
                  <button onClick={() => deleteProduto(prod._id)} className="btn-ghost action-btn text-red">
                    <Icons.Trash /> Apagar
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </main>

      {/* MODAL DE CADASTRO/EDIÇÃO */}
      {modalOpen && (
        <div className="modal-overlay animate-fade-in">
          <div className="modal-content">
            
            <div className="modal-header">
              <h2>{form.id ? 'Editar Produto' : 'Novo Produto'}</h2>
              <button onClick={() => setModalOpen(false)} className="btn-close"><Icons.Close /></button>
            </div>

            <form onSubmit={saveProduto} className="modal-body">
              
              {/* UPLOAD DE IMAGEM CENTRALIZADO */}
              <div className="upload-section">
                <label htmlFor="foto-upload" className="image-uploader">
                  {form.imagemBase64 ? (
                    <img src={form.imagemBase64} alt="Preview" className="image-preview" />
                  ) : (
                    <div className="image-placeholder">
                      <Icons.Camera />
                      <span>Adicionar Foto</span>
                    </div>
                  )}
                  <div className="image-overlay">Alterar Imagem</div>
                </label>
                <input id="foto-upload" type="file" accept="image/*" onChange={handleImageUpload} hidden />
              </div>

              <div className="grid-2">
                <div className="field-group col-span-2 sm-col-span-1">
                  <label>Nome do Produto</label>
                  <input required value={form.nome} onChange={e=>setForm({...form, nome: e.target.value})} className="input-base" placeholder="Ex: Lente Visão Simples" />
                </div>
                <div className="field-group">
                  <label>Categoria</label>
                  <div className="select-wrapper">
                    <select value={form.categoria} onChange={e=>setForm({...form, categoria: e.target.value})} className="input-base select-base">
                      <option value="Lente">Lente</option>
                      <option value="Armação">Armação</option>
                      <option value="Acessório">Acessório</option>
                      <option value="Limpeza">Limpeza</option>
                      <option value="Diversos">Diversos</option>
                    </select>
                  </div>
                </div>
              </div>

              <div className="grid-2">
                <div className="field-group">
                  <label>Preço de Venda (R$)</label>
                  <input required type="number" step="0.01" value={form.preco} onChange={e=>setForm({...form, preco: e.target.value})} className="input-base" placeholder="0.00" />
                </div>
                <div className="field-group">
                  <label>Quantidade em Estoque</label>
                  <input required type="number" value={form.estoque} onChange={e=>setForm({...form, estoque: e.target.value})} className="input-base" placeholder="0" />
                </div>
              </div>

              <div className="field-group">
                <label>Descrição (Opcional)</label>
                <textarea rows="3" value={form.descricao} onChange={e=>setForm({...form, descricao: e.target.value})} className="input-base textarea-base" placeholder="Detalhes técnicos, cor, modelo..."></textarea>
              </div>

              <div className="modal-footer">
                <button type="button" onClick={() => setModalOpen(false)} className="btn-secondary">Cancelar</button>
                <button type="submit" disabled={saving} className="btn-primary">
                  {saving ? 'Salvando...' : form.id ? 'Salvar Alterações' : 'Cadastrar Produto'}
                </button>
              </div>

            </form>
          </div>
        </div>
      )}
    </div>
  );
}

// ==================================================================================
// ESTILOS GLOBAIS (Design System Vercel/Stripe)
// ==================================================================================
const GlobalStyles = () => (
  <style>{`
    @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');

    :root {
      --bg-main: #F4F4F5;
      --surface: #FFFFFF;
      --surface-hover: #FAFAFA;
      
      --text-main: #09090B;
      --text-muted: #52525B;
      --text-light: #A1A1AA;
      
      --border: #E4E4E7;
      --border-hover: #D4D4D8;
      
      --black: #09090B;
      --red: #EF4444;
      --red-bg: #FEF2F2;
      
      --radius-sm: 8px;
      --radius-md: 12px;
      --radius-lg: 16px;
      --radius-pill: 9999px;
      
      --font-sans: 'Inter', -apple-system, sans-serif;
    }

    * { box-sizing: border-box; margin: 0; padding: 0; outline: none; }
    body { font-family: var(--font-sans); background: var(--bg-main); color: var(--text-main); -webkit-font-smoothing: antialiased; line-height: 1.5; }

    /* LAYOUT BÁSICO */
    .layout-container { max-width: 1120px; margin: 0 auto; padding: 40px 24px; min-height: 100vh; }

    /* ANIMAÇÃO */
    .animate-fade-in { animation: fadeIn 0.3s cubic-bezier(0.16, 1, 0.3, 1) forwards; }
    @keyframes fadeIn { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }

    /* HEADER */
    .page-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 40px; flex-wrap: wrap; gap: 16px; }
    .header-left { display: flex; align-items: center; gap: 16px; }
    
    .btn-icon { width: 40px; height: 40px; background: var(--surface); border: 1px solid var(--border); border-radius: var(--radius-sm); display: grid; place-items: center; cursor: pointer; color: var(--text-muted); transition: 0.2s; box-shadow: 0 1px 2px rgba(0,0,0,0.02); }
    .btn-icon:hover { color: var(--text-main); border-color: var(--black); }

    .header-titles h1 { font-size: 24px; font-weight: 700; letter-spacing: -0.02em; margin-bottom: 4px; }
    .header-titles p { font-size: 14px; color: var(--text-muted); }

    /* BOTOES GERAIS */
    .btn-primary { background: var(--black); color: white; border: none; padding: 0 20px; height: 40px; border-radius: var(--radius-pill); font-size: 14px; font-weight: 500; display: inline-flex; align-items: center; justify-content: center; gap: 8px; cursor: pointer; transition: 0.2s; box-shadow: 0 2px 4px rgba(0,0,0,0.05); }
    .btn-primary:hover:not(:disabled) { opacity: 0.85; transform: translateY(-1px); }
    .btn-primary:disabled { opacity: 0.5; cursor: not-allowed; transform: none; }

    .btn-secondary { background: var(--surface); color: var(--text-main); border: 1px solid var(--border); padding: 0 20px; height: 40px; border-radius: var(--radius-pill); font-size: 14px; font-weight: 500; display: inline-flex; align-items: center; justify-content: center; cursor: pointer; transition: 0.2s; box-shadow: 0 1px 2px rgba(0,0,0,0.02); }
    .btn-secondary:hover:not(:disabled) { background: var(--bg-main); border-color: var(--border-hover); }

    .btn-ghost { background: transparent; border: none; font-size: 13px; font-weight: 500; color: var(--text-muted); cursor: pointer; display: inline-flex; align-items: center; gap: 6px; padding: 6px 12px; border-radius: var(--radius-sm); transition: 0.2s; }
    .btn-ghost:hover { background: var(--bg-main); color: var(--black); }
    .text-red { color: var(--text-muted); }
    .text-red:hover { background: var(--red-bg); color: var(--red); }

    /* ========================================================
       GRID DE PRODUTOS
       ======================================================== */
    .products-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(260px, 1fr)); gap: 24px; }
    
    .product-card { background: var(--surface); border: 1px solid var(--border); border-radius: var(--radius-md); overflow: hidden; display: flex; flex-direction: column; transition: all 0.3s ease; box-shadow: 0 2px 4px rgba(0,0,0,0.02); }
    .product-card:hover { transform: translateY(-4px); box-shadow: 0 12px 24px -8px rgba(0,0,0,0.08); border-color: var(--border-hover); }

    .card-image-box { height: 180px; background: var(--bg-main); position: relative; border-bottom: 1px solid var(--border); }
    .product-image { width: 100%; height: 100%; object-fit: cover; }
    .no-image { width: 100%; height: 100%; display: flex; align-items: center; justify-content: center; color: var(--text-light); background: var(--surface-hover); }
    
    .category-badge { position: absolute; top: 12px; right: 12px; background: rgba(255, 255, 255, 0.9); backdrop-filter: blur(4px); border: 1px solid rgba(0,0,0,0.05); color: var(--text-main); font-size: 11px; font-weight: 600; padding: 4px 10px; border-radius: var(--radius-pill); text-transform: uppercase; letter-spacing: 0.05em; }

    .card-body { padding: 20px; display: flex; flex-direction: column; flex: 1; }
    .product-info { margin-bottom: 20px; flex: 1; }
    .product-name { font-size: 16px; font-weight: 600; color: var(--text-main); margin-bottom: 4px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; letter-spacing: -0.01em; }
    .product-desc { font-size: 13px; color: var(--text-muted); line-height: 1.4; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; }

    .product-metrics { display: flex; justify-content: space-between; align-items: center; padding-top: 16px; border-top: 1px dashed var(--border); }
    .product-price { font-size: 18px; font-weight: 700; color: var(--text-main); letter-spacing: -0.02em; }
    .product-stock { font-size: 12px; font-weight: 500; color: var(--text-muted); background: var(--bg-main); padding: 4px 8px; border-radius: var(--radius-sm); }
    .stock-out { background: var(--red-bg); color: var(--red); }

    .card-actions { display: flex; justify-content: space-between; padding: 12px 16px; background: var(--surface-hover); border-top: 1px solid var(--border); }
    .action-btn { flex: 1; justify-content: center; }

    /* ========================================================
       MODAL (Estilo Vercel)
       ======================================================== */
    .modal-overlay { position: fixed; inset: 0; background: rgba(0, 0, 0, 0.4); backdrop-filter: blur(4px); z-index: 999; display: flex; align-items: center; justify-content: center; padding: 20px; }
    .modal-content { background: var(--surface); width: 100%; max-width: 500px; border-radius: var(--radius-lg); box-shadow: 0 25px 50px -12px rgba(0,0,0,0.25); border: 1px solid var(--border); overflow: hidden; display: flex; flex-direction: column; max-height: 90vh; }
    
    .modal-header { padding: 24px; border-bottom: 1px solid var(--border); display: flex; justify-content: space-between; align-items: center; }
    .modal-header h2 { font-size: 18px; font-weight: 600; letter-spacing: -0.01em; }
    .btn-close { background: transparent; border: none; color: var(--text-muted); cursor: pointer; display: grid; place-items: center; border-radius: var(--radius-sm); padding: 4px; transition: 0.2s; }
    .btn-close:hover { background: var(--bg-main); color: var(--black); }

    .modal-body { padding: 24px; overflow-y: auto; display: flex; flex-direction: column; gap: 20px; }

    /* UPLOAD MODAL */
    .upload-section { display: flex; justify-content: center; margin-bottom: 8px; }
    .image-uploader { width: 120px; height: 120px; border-radius: 50%; border: 1px dashed var(--border-hover); background: var(--bg-main); display: flex; align-items: center; justify-content: center; cursor: pointer; position: relative; overflow: hidden; transition: 0.2s; }
    .image-uploader:hover { border-color: var(--black); }
    .image-placeholder { display: flex; flex-direction: column; align-items: center; gap: 8px; color: var(--text-muted); }
    .image-placeholder span { font-size: 11px; font-weight: 500; }
    .image-preview { width: 100%; height: 100%; object-fit: cover; }
    
    .image-overlay { position: absolute; inset: 0; background: rgba(0,0,0,0.5); color: white; font-size: 12px; font-weight: 500; display: flex; align-items: center; justify-content: center; opacity: 0; transition: 0.2s; }
    .image-uploader:hover .image-overlay { opacity: 1; }

    /* FORM INPUTS */
    .grid-2 { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; }
    .col-span-2 { grid-column: span 2; }
    
    .field-group { display: flex; flex-direction: column; gap: 6px; }
    .field-group label { font-size: 13px; font-weight: 500; color: var(--text-main); }
    
    .input-base { width: 100%; height: 40px; padding: 0 12px; background: var(--surface); border: 1px solid var(--border); border-radius: var(--radius-sm); font-size: 14px; color: var(--text-main); font-family: inherit; transition: 0.2s; box-shadow: 0 1px 2px rgba(0,0,0,0.02); }
    .input-base::placeholder { color: var(--text-light); }
    .input-base:focus { border-color: var(--black); box-shadow: 0 0 0 1px var(--black); outline: none; }
    .textarea-base { height: auto; padding: 12px; resize: vertical; min-height: 80px; }

    .select-wrapper { position: relative; }
    .select-base { appearance: none; padding-right: 32px; cursor: pointer; }
    .select-wrapper::after { content: "▼"; font-size: 10px; position: absolute; right: 12px; top: 50%; transform: translateY(-50%); color: var(--text-muted); pointer-events: none; }

    .modal-footer { display: flex; justify-content: flex-end; gap: 12px; padding-top: 24px; border-top: 1px solid var(--border); margin-top: 8px; }

    /* EMPTY STATES */
    .empty-state { grid-column: 1/-1; display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 80px 20px; text-align: center; border: 1px dashed var(--border-hover); border-radius: var(--radius-lg); background: var(--surface); }
    .empty-icon { width: 48px; height: 48px; border-radius: 50%; background: var(--bg-main); display: grid; place-items: center; color: var(--text-muted); margin-bottom: 16px; }
    .empty-state h3 { font-size: 16px; font-weight: 600; margin-bottom: 8px; }
    .empty-state p { font-size: 14px; color: var(--text-muted); margin-bottom: 24px; max-width: 300px; }
    
    .spinner { width: 32px; height: 32px; border: 3px solid var(--border); border-top-color: var(--black); border-radius: 50%; animation: spin 1s linear infinite; margin-bottom: 16px; }

    /* RESPONSIVIDADE */
    @media (max-width: 600px) {
      .layout-container { padding: 24px 16px; }
      .header-titles h1 { font-size: 20px; }
      .btn-primary { width: 100%; justify-content: center; margin-top: 16px; }
      
      .products-grid { grid-template-columns: 1fr; }
      
      .sm-col-span-1 { grid-column: span 1; }
      .grid-2 { grid-template-columns: 1fr; }
      
      .modal-content { max-height: 95vh; }
      .modal-footer { flex-direction: column; }
      .modal-footer button { width: 100%; }
    }
  `}</style>
);